module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 52
// module chunks = 0